import MissionControl from '@/sdk/missionControl'

import OptimizeTest from './OptimizeTest'
import parseOptimizeCookie from './parseOptimizeCookie'
import { LoadedTests } from './testConfig'

// @TODO: this factory is a bit ugly
export default function GoogleOptimizeServiceFactory(
  cookieParser: Function,
): GoogleOptimizeService {
  return new GoogleOptimizeService({
    gaExpCookieString: cookieParser('_gaexp'),
    logger: require('debug')('careship:google-optimize'),
  })
}

export class GoogleOptimizeService {
  private readonly logger: GoogleOptimizeServiceLogger

  private testsLoaded: LoadedTests

  constructor(props: GoogleOptimizeServiceParams) {
    this.logger = props.logger
    this.testsLoaded = {}

    const cookieString = props.gaExpCookieString || ''
    this.loadTestsFromString(cookieString)
  }

  private static isTestPastExpirationDate(expiration: number): boolean {
    const today = new Date()
    const MILISECONDS_PER_DAY = 8.64e7
    const daysSinceUnixEpoch = Math.floor(today.valueOf() / MILISECONDS_PER_DAY)
    return daysSinceUnixEpoch > expiration
  }

  private isTestExpired(testName: string): boolean {
    const test = this.getTest(testName)
    const expiration = test ? test.expiration : 0
    return GoogleOptimizeService.isTestPastExpirationDate(expiration)
  }

  private getTest(testName: string): OptimizeTest | null {
    const id = this.getTestIdFromMissionControl(testName)
    const test = Object.prototype.hasOwnProperty.call(this.testsLoaded, id)
      ? this.testsLoaded[id]
      : null

    this.logger('getTest -> %s => %O', testName, test)

    return test
  }

  private getTestIdFromMissionControl(testName: string): string {
    const feature = MissionControl.get(testName)
    this.logger('getTestIdFromMissionControl -> testName is %s', testName)
    this.logger('getTestIdFromMissionControl -> feature is %O', feature)

    return feature && 'value' in feature && typeof feature.value === 'string'
      ? feature.value
      : '0'
  }

  private loadTestsFromString(gaExpCookieString: string): void {
    this.testsLoaded = parseOptimizeCookie(gaExpCookieString)

    this.logger('loadTestsFromString -> cookie is %s', gaExpCookieString)
    this.logger('loadTestsFromString -> result is %O', this.testsLoaded)
  }

  public getTestVariant(testName: string): string {
    if (this.isTestExpired(testName)) {
      return '0'
    }

    const id = this.getTestIdFromMissionControl(testName)
    return this.testsLoaded[id] ? this.testsLoaded[id].variant : '0'
  }

  public reloadTests(gaExpCookieString: string): void {
    this.loadTestsFromString(gaExpCookieString)
  }

  public getAllTests(): LoadedTests {
    return this.testsLoaded
  }
}

type GoogleOptimizeServiceParams = {
  gaExpCookieString: string | null // browser-cookies' get method has this signature
  logger: GoogleOptimizeServiceLogger
}

type GoogleOptimizeServiceLogger = (...args: any) => void | Console
